import React from 'react'

const ReportsVolumetryMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_1037_33467)"
      fillOpacity="0.1"
    />
    <path
      d="M18.0035 8V12.0072H22.0108L18.0035 8ZM16.9945 12.0072V8H11.4882C10.6522 8 9.98914 8.66306 9.98914 9.4991V22.5009C9.98914 23.3369 10.6522 24 11.4882 24H20.5117C21.3477 24 22.0108 23.3369 22.0108 22.5009V12.9874H18.0324C17.4558 13.0162 16.9945 12.555 16.9945 12.0072ZM18.4936 21.0018H13.5063C13.218 21.0018 13.0162 20.7712 13.0162 20.5117C13.0162 20.2234 13.2468 20.0216 13.5063 20.0216H18.5225C18.8108 20.0216 19.0126 20.2523 19.0126 20.5117C19.0126 20.8 18.7819 21.0018 18.4936 21.0018ZM18.4936 19.0126H13.5063C13.218 19.0126 13.0162 18.782 13.0162 18.5225C13.0162 18.2342 13.2468 18.0324 13.5063 18.0324H18.5225C18.8108 18.0324 19.0126 18.2631 19.0126 18.5225C19.0126 18.782 18.7819 19.0126 18.4936 19.0126ZM19.0126 16.5045C19.0126 16.7928 18.7819 16.9946 18.5225 16.9946H13.5063C13.218 16.9946 13.0162 16.764 13.0162 16.5045C13.0162 16.2162 13.2468 16.0144 13.5063 16.0144H18.5225C18.7819 16.0144 19.0126 16.245 19.0126 16.5045Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1037_33467"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default ReportsVolumetryMenu
